export default {
  form: {
    amount: {
      label: 'Prijs',
    },
    threshold: {
      label: 'Maandelijkse omzet',
    },
    has_pricing_tiers: {
      label: 'Prijswijzigingen op basis van maandelijkse omzet',
    },
    tax_included: {
      label: 'Btw inbegrepen',
    },
  },
  buttons: {
    add_tier: 'Niveau toevoegen',
  },
};
